<template>
  <div class="pensum-hours__container">
    <div class="row">
      <div
        v-for="dato in datos"
        :key="dato.body"
        class="col-3 px-1 d-md-flex"
      >
        <Hour
          :body="''+dato.body"
          :title="''+dato.title"
          :text="dato.text"
        />
      </div>
    </div>
  </div>
</template>
<script>
import Hour from './Hour.vue';
import CONFIG from '../config';

export default {
    name: 'PensumHours',
    components: {
        Hour,
    },
    props: {
        hours: {
            type: Object,
            required: true,
        },
    },
    computed: {
        datos() {
            const keys = Object.keys(this.hours);
            const values = Object.values(this.hours);
            const retorno = [];
            const texts = CONFIG.textForSquares;
            for (let i = 0; i < keys.length; i += 1) {
                retorno.push({ title: values[i] ? values[i] : '', body: this.parse(keys[i]), text: texts[keys[i].toLowerCase()] });
            }
            return retorno;
        },
    },
    methods: {
        parse(text) {
            // OJo con las tildes
            if (text.toLowerCase() === 'teoricas' || text.toLowerCase() === 'practicas') {
                return `TOTAL DE HORAS ${text.toUpperCase()}`;
            }
            return `TOTAL DE ${text.toUpperCase()}`;
        },
    },
};

</script>
<style lang="scss">
.pensum-hours__container{
  max-width: 660px;
  margin: 0 auto;
}
</style>
